// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import FirstView from '@/views/customer/FirstView.vue'
import OrderMenu from '@/views/customer/OrderMenu.vue'
import CartConfirm from '@/views/customer/CartConfirm.vue'
import OrderConfirm from '@/views/customer/OrderConfirm.vue'
import Login from '@/views/admin/Login.vue'
import Home from '@/views/admin/Home.vue'
import MenuManage from '@/views/admin/MenuManage.vue'
import TableManage from '@/views/admin/TableManage.vue'
import ServeManage from '@/views/admin/ServeManage.vue'
import TableDetail from '@/views/admin/TableDetail.vue'
import Forbidden from '@/views/common/Forbidden.vue'
import NotFound from '@/views/common/NotFound.vue'
import NetworkError from '@/views/common/NetworkError.vue'
import SystemError from '@/views/common/SystemError.vue'
import Statistics from '@/views/admin/Statistics.vue'
import { tenantId } from '@/utils/tenantUrl'

const routes = [
  {
    path: '',
    name: 'FirstView',
    component: FirstView,
    meta: { requiresAuth: false }
  },
  {
    path: '/orderMenu',
    name: 'OrderMenu',
    component: OrderMenu,
    meta: { requiresAuth: false }
  },
  {
    path: '/cartConfirm',
    name: 'CartConfirm',
    component: CartConfirm,
    meta: { requiresAuth: false }
  },
  {
    path: '/orderComfirm',
    name: 'OrderConfirm',
    component: OrderConfirm,
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/admin',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true, permissionAuth: false },
    children: [
      {
        path: 'menu',
        name: 'MenuManage',
        component: MenuManage,
        meta: { title: '菜单管理', requiresAuth: true, permissionAuth: true, key: 'menu'}
      },
      {
        path: 'table',
        name: 'TableManage',
        component: TableManage,
        meta: { title: '桌台管理', requiresAuth: true, permissionAuth: true, key: 'table' }
      },
      {
        path: 'serve',
        name: 'ServeManage',
        component: ServeManage,
        meta: { title: '上菜管理', requiresAuth: true, permissionAuth: true, key: 'serve' }
      },
      {
        path: 'table-detail',
        name: 'TableDetail',
        component: TableDetail,
        meta: { title: '桌台详情', requiresAuth: true, permissionAuth: false }
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: Statistics,
        meta: { title: '统计', requiresAuth: true, permissionAuth: true, key: 'serve'  }
      }
    ]
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: Forbidden,
    meta: { requiresAuth: false }
  },
  {
    path: '/not-found',
    name: 'NotFound',
    component: NotFound,
    meta: { requiresAuth: false }
  },
  {
    path: '/system-error',
    name: 'SystemError',
    component: SystemError,
    meta: { requiresAuth: false }
  },
  {
    path: '/network-error',
    name: 'NetworkError',
    component: NetworkError,
    meta: { requiresAuth: false }
  },
  // 可以添加更多路由
  {
    path: '/:pathMatch(.*)*',
    redirect: '/not-found'
  }
]

const router = createRouter({
  history: createWebHistory(tenantId),
  routes
})

router.beforeEach((to, from, next)=>{

  // tenant不存在的情况下，跳403画面
  if(!tenantId){
    next({name: 'Forbidden'})
    return
  }

  // 迁移画面需要token验证的场合
  if (to.meta.requiresAuth) {
    // token不存在的场合，迁移到login画面
    if (!sessionStorage.getItem('token')){
      next({name: 'Login'})
      return
    }

    // 迁移画面需要权限验证的场合
    if (to.meta.permissionAuth) {
      // 没有权限的场合，迁移到login画面
      if(!sessionStorage.getItem('permission')?.split(',')?.includes(to.meta.key)){
        next({name: 'Login'})
        return
      }
    }
  }

  next()
})

export default router